import { useState, useEffect, type RefObject } from 'react';

export function useIntersection(
  root: RefObject<HTMLElement | null>,
  target: RefObject<HTMLElement | null>,
  options?: {
    rootMargin?: string;
    threshold?: number | number[];
  },
): boolean {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const intersectionCallback = ([{ isIntersecting }]: IntersectionObserverEntry[]): void =>
      setIsActive(isIntersecting);

    const observer = new IntersectionObserver(intersectionCallback, {
      root: root ? root?.current : null,
      rootMargin: options?.rootMargin ?? '0px',
      threshold: options?.threshold ?? 1.0,
    });

    if (target?.current) {
      observer.observe(target.current);
    }

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isActive;
}
